var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-column"},[_vm._t("content"),_c('div',{staticClass:"d-flex filter-actions pt-4"},[_vm._t("actions")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }